import { createContext } from "react";
import { UseMutateFunction } from "@tanstack/react-query";
import { TotpUserFactor } from "@okta/okta-sdk-nodejs";

import { EnrollTotpData } from "hooks/useEnrollTotpFactor";
import { EnrollTotpData as AuthEnrollTotpData } from "pages/register/hooks/useAuthEnrollTotp";

import { AuthTransaction } from "pages/register/types/authTransaction";
import { OktaError } from "types/oktaError/oktaError";
import { QrCodeData } from "../types/qrCodeData";

type TotpQrCodeContextType = {
  qrCodeData: QrCodeData | undefined;
  requestEnrollTotp: UseMutateFunction<TotpUserFactor, unknown, EnrollTotpData>;
  resetQrCodeData: () => void;
  authEnrollTotp: UseMutateFunction<
    AuthTransaction,
    OktaError,
    AuthEnrollTotpData
  >;
};

const TotpQrCodeContext = createContext<TotpQrCodeContextType>({
  qrCodeData: undefined,
  requestEnrollTotp: () => undefined,
  resetQrCodeData: () => undefined,
  authEnrollTotp: () => undefined,
});

export default TotpQrCodeContext;
